import { render, staticRenderFns } from "./SurveyScore.vue?vue&type=template&id=680892b6&"
import script from "./SurveyScore.vue?vue&type=script&lang=js&"
export * from "./SurveyScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports